/** Strict saved native inputs. Toolbox has its own catalogue-backed contract. */
import { z } from "zod";
import { CanonicalGenerationDraftV1Schema } from "./schema";
import {
  TOOLBOX_CUSTOM_TOPIC_NAME_MAX, ToolboxCustomGenerationDraftV1Schema, ToolboxGenerationDraftV1Schema,
} from "./toolbox-talk";

/** Partial Toolbox answers are still versioned and strictly named for autosave. */
export const ToolboxEditableDraftV1Schema = z.object({
  generationDraftVersion: z.literal(1), documentType: z.literal("TOOLBOX_TALK"),
  answers: z.object({
    topicSlug: z.string(), keyPoints: z.array(z.string()), dos: z.array(z.string()),
    donts: z.array(z.string()),
    questions: z.array(z.object({ question: z.string(), answer: z.string() }).strict()),
    additionalNotes: z.string().nullable(), deliveredBy: z.string(),
    deliveryDate: z.string(), duration: z.string(),
  }).strict(),
}).strict();

/** User-authored topic autosave: same completeness-of-shape rules as the
 * library editable draft, with the authored name and content instead of a
 * catalogue slug (#2805). */
export const ToolboxCustomEditableDraftV1Schema = z.object({
  generationDraftVersion: z.literal(1), documentType: z.literal("TOOLBOX_TALK"),
  customTopicName: z.string().max(TOOLBOX_CUSTOM_TOPIC_NAME_MAX), answers: z.object({
    keyPoints: z.array(z.string()), dos: z.array(z.string()),
    donts: z.array(z.string()),
    questions: z.array(z.object({ question: z.string(), answer: z.string() }).strict()),
    additionalNotes: z.string().nullable(), deliveredBy: z.string(),
    deliveryDate: z.string(), duration: z.string(),
  }).strict(),
}).strict();

/** Saved draft and recovery parser; completion rules belong to the wire parser below. */
export const RecoverableGenerationDraftV1Schema = z.union([
  CanonicalGenerationDraftV1Schema, ToolboxEditableDraftV1Schema, ToolboxCustomEditableDraftV1Schema,
]);
export type RecoverableGenerationDraftV1 = z.infer<typeof RecoverableGenerationDraftV1Schema>;

export const NativeGenerationDraftV1Schema = z.union([
  CanonicalGenerationDraftV1Schema,
  ToolboxGenerationDraftV1Schema,
  ToolboxCustomGenerationDraftV1Schema,
]);
export type NativeGenerationDraftV1 = z.infer<typeof NativeGenerationDraftV1Schema>;
